import { GET_MESSAGE, SET_MESSAGE } from "../store/sysMessage/const";

export default function fetchComp() {
    const apiGetUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_richiesta.asp",
        apiSetUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_invio.asp",
        apiLoginUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_login.asp",
        apiCheckAuthUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_check_auth.asp",
        apiStatsUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_statistiche.asp",
        apiSaveAdUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_schede.asp",
        apiUploadUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_upload.asp",
        apiIp = "https://www.outletarredamento.it/api/back_end/geoip.asp",
        apiEditMediaUrl = "https://www.outletarredamento.it/api/back_end/rivenditori/v1_edit_media.asp",
        logUrl = "https://api.preludeadv.it/api/v1/out_v1/log_errore.asp";

    async function get(requestObj) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        let data = await this.$http.post(apiGetUrl, params).then(response => {
            if (response.data) {
                if (response.data.auth == 'ko') {
                    const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
                    sysMessageStateObj.haveContent = true;
                    sysMessageStateObj.messageText = `Sessione scaduta, rieseguire l'accesso`;
                    sysMessageStateObj.messageType = 'error';
                    this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
                    this.$router.push('/Signin')
                }
            }
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function getSpecific(requestObj, givenObj) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        Object.entries(givenObj).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiGetUrl, params).then(response => {
            if (response.data) {
                if (response.data.auth == 'ko') {
                    const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
                    sysMessageStateObj.haveContent = true;
                    sysMessageStateObj.messageText = `Sessione scaduta, rieseguire l'accesso`;
                    sysMessageStateObj.messageType = 'error';
                    this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
                    this.$router.push('/Signin')
                }
            }
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function set(requestObj, postData) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiSetUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    function noRespRequest(requestObj, givenObj) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        Object.entries(givenObj).forEach(([key, value]) => {
            params.append(key, value);
        });
        this.$http.post(apiGetUrl, params)
    }

    async function login(postData) {
        const params = new URLSearchParams();
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiLoginUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function checkAuth(postData) {
        const params = new URLSearchParams();
        params.append('azione', 'accedi');
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiCheckAuthUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function stats(requestObj, postData = null) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        if (postData) {
            Object.entries(postData).forEach(([key, value]) => {
                params.append(key, value);
            });
        }
        let data = await this.$http.post(apiStatsUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function saveAd(postData) {
        const params = new URLSearchParams();
        params.append('cosa', 'aggiungi_scheda');
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiSaveAdUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function removeAd(postData) {
        const params = new URLSearchParams();
        params.append('cosa', 'elimina_scheda');
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiSaveAdUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function uploadMedia(adId, adUrl, file) {
        const url = new URL(apiUploadUrl),
            formData = new FormData();

        url.searchParams.append('id_scheda', adId);
        url.searchParams.append('urlpagina', adUrl);
        formData.append('file', file, file.name);
        let data = await this.$http.post(url.href, formData, { headers: { 'Content-Type': 'multipart/form-data' }, maxBodyLength: 100000000, maxContentLength: 100000000, emulateJSON: true }).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function getImageFromUrl(url) {
        const params = new URLSearchParams();
        params.append('cosa', 'upload_url');
        params.append('url', url);
        let data = await this.$http.post(apiEditMediaUrl, params, {
            responseType: 'blob',
            timeout: 30000,
        }).then(response => {
            return response
        }, response => {
            return [];
        });
        return data;
    }

    async function editMedia(requestObj, givenObj) {
        const params = new URLSearchParams();
        params.append('cosa', requestObj);
        Object.entries(givenObj).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiEditMediaUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    async function updateAd(postData) {
        const params = new URLSearchParams();
        params.append('cosa', 'modifica_scheda');
        Object.entries(postData).forEach(([key, value]) => {
            params.append(key, value);
        });
        let data = await this.$http.post(apiSaveAdUrl, params).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    function logger(message, token = null) {
        const params = new URLSearchParams();
        params.append('chi', 'riv');
        params.append('token', token ?? '')
        params.append('message', message)
        this.$http.post(logUrl, params)
    }

    async function getIp() {
        let data = await this.$http.get(apiIp).then(response => {
            return response.data
        }, response => {
            return [];
        });
        return data;
    }

    return {
        get,
        getSpecific,
        set,
        noRespRequest,
        login,
        checkAuth,
        stats,
        saveAd,
        removeAd,
        uploadMedia,
        getImageFromUrl,
        editMedia,
        updateAd,
        logger,
        getIp,
    }
}